<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex align-items-center mb-3">
        <div class="avatar-xs me-3">
          <span
            class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-18"
          >
            <i :class="icon"></i>
          </span>
        </div>
        <h5 class="font-size-14 mb-0">
          {{ $t("menuitems.dashboards.list.weatherReport") }}
        </h5>
      </div>
      <div class="text-muted mt-4 mb-2" v-if="temperature">
        <h4>{{ temperature }} in {{ region }}</h4>

        <div class="d-flex">
          <span class="text-truncate"
            >{{ weather }} <img :src="img" width="32" alt=""
          /></span>
        </div>
      </div>
      <div class="text-center" v-else>
        <h5 class="p-4">Loading...</h5>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import config from "../../constants/config";

export default {
  data() {
    return {
      title: "Weather Report",
      temperature: null,
      icon: "",
      region: "",
      updateTime: "",
      weather: "",
      img: "",
      isWeatherLoaded: false,
    };
  },
  async mounted() {
    try {
      await this.loadWeatherReport();
    } catch (e) {
      console.error(e);
      this.isWeatherLoaded = false;
    }
  },
  computed: {
    location() {
      return this.$store.getters["socket/dashboard"].statistics.location;
    },
  },
  watch: {
    location: async function () {
      if (!this.isWeatherLoaded) await this.loadWeatherReport();
    },
  },
  methods: {
    async loadWeatherReport() {
      const location = await this.getCurrentLocation();
      const res = await axios.get(
        `${config.BASE_URL}${config.API_ROUTES.DASHBOARD.WEATHER}?lat=${location.lat}&long=${location.long}`
      );

      const currentClimate = res.data.current;
      this.region = res.data.location.region;
      this.weather = currentClimate.condition.text;
      this.img = `http:${currentClimate.condition.icon}`;
      this.updateTime = res.data.location.localtime;
      this.temperature = `${Math.round(currentClimate.temp_c)}° C`;
      this.isWeatherLoaded = true;

      // Set day image
      if (currentClimate.is_day == 0) {
        this.icon = `bx bx-moon`;
      } else {
        this.icon = `bx bx-sun`;
      }
    },
    getCurrentLocation() {
      return new Promise((resolve, reject) => {
        if (!this.location.center_lat) return reject(false);

        if (this.location) {
          return resolve({
            lat: this.location.center_lat,
            long: this.location.center_long,
          });
        }

        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((pos) => {
            return resolve({
              lat: pos.coords.latitude,
              long: pos.coords.longitude,
            });
          });
        } else {
          return reject("Geolocation is not supported by this browser.");
        }
      });
    },
  },
};
</script>

<style scoped>
.bg-img-day {
  background: url("../../assets/icons/sunny.jpg");
  background-size: cover;
}

.bg-img-night {
  background: url("../../assets/icons/night.jpg");
  background-size: cover;
}
</style>